import { render, staticRenderFns } from "./KommunetorgetTopicPage.vue?vue&type=template&id=24e3d0b6&"
import script from "./KommunetorgetTopicPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetTopicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e3d0b6')) {
      api.createRecord('24e3d0b6', component.options)
    } else {
      api.reload('24e3d0b6', component.options)
    }
    module.hot.accept("./KommunetorgetTopicPage.vue?vue&type=template&id=24e3d0b6&", function () {
      api.rerender('24e3d0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetTopicPage.vue"
export default component.exports